module.exports = __webpack_public_path__ + "roboto-regular-webfont-b06ad091cf548c38401f3e5883cb36a2.woff";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto/roboto-regular-webfont.woff
// module id = 841
// module chunks = 76